// ============================================================================
// Tipos derivados do schema introspectado ao vivo (projeto viflrlxwvziimdbbcgtf).
// O app LÊ clientes/contratos/grupos e a view v_onboarding_board; LÊ e ESCREVE
// handoffs / onboarding_pipeline / onboarding_stage_history.
// ============================================================================

/** Valores reais de contratos.status (CHECK constraint no banco). */
export type StatusContrato =
  | "rascunho"
  | "em_revisao_interna"
  | "aguardando_assinatura"
  | "ativo"
  | "rescindido"
  | "cancelado";

export type ModeloContrato = "PF" | "PJ";

/** Planos canônicos (valores exatos exigidos pelo workflow de contrato). */
export type Plano =
  | "Light Performance"
  | "Light Performance + Social"
  | "Full Performance"
  | "Full Performance + Social";

export const PLANOS: Plano[] = [
  "Light Performance",
  "Light Performance + Social",
  "Full Performance",
  "Full Performance + Social",
];

/** Linha da view v_onboarding_board — fonte do board (28 colunas). */
export interface BoardRow {
  cliente_id: string;
  cliente_nome: string | null;
  /** Nome oficial do projeto na Reach Up (ex.: "Dra. Tayse Oliveira"). Não é a razão social. */
  nome_projeto: string | null;
  tipo_pessoa: string | null;
  area_atendimento: string | null;
  has_social: boolean | null;
  ativo: boolean | null;
  stage: number;
  handoff_em: string | null;
  contrato_enviado_em: string | null;
  contrato_assinado_em: string | null;
  whatsapp_grupo_em: string | null;
  onboarding_msg_em: string | null;
  reuniao_onboarding_em: string | null;
  onboarding_concluido_em: string | null;
  treino_comercial_em: string | null;
  treino_conteudo_em: string | null;
  atualizado_em: string | null;
  atualizado_por: string | null;
  observacoes: string | null;
  contrato_id: string | null;
  contrato_status: StatusContrato | null;
  d4sign_document_uuid: string | null;
  modelo_contrato: ModeloContrato | null;
  valor_mensal_numero: number | null;
  vigencia_meses: number | null;
  data_inicio_vigencia: string | null;
  data_fim_vigencia: string | null;
  data_envio_para_assinatura: string | null;
  data_ativacao: string | null;
  // Consolidação por documento (CPF/CNPJ) — colunas acrescentadas à view:
  doc: string | null;
  n_contratos: number;
  contrato_confirmado_em: string | null;
  contrato_confirmado_por: string | null;
  cliente_ids: string[];
  // Briefing de fechamento gerado pelo n8n a partir das transcrições.
  briefing_resumo: string | null;
  briefing_gerado_em: string | null;
  clickup_projeto_url: string | null;
}

/** Linha da view v_cliente_contratos — todos os contratos do cliente. */
export interface ContratoResumo {
  contrato_id: string;
  cliente_id: string;
  doc: string | null;
  status: StatusContrato;
  rank: number;
  created_at: string | null;
  data_envio_para_assinatura: string | null;
  data_ativacao: string | null;
  valor_mensal_numero: number | null;
  modelo_contrato: ModeloContrato | null;
  vigencia_meses: number | null;
  data_inicio_vigencia: string | null;
  data_fim_vigencia: string | null;
  d4sign_document_uuid: string | null;
}

/** Tabela onboarding_pipeline — 1 linha por cliente (PK cliente_id). */
export interface OnboardingPipeline {
  cliente_id: string;
  contrato_id: string | null;
  handoff_id: string | null;
  stage: number;
  handoff_em: string | null;
  contrato_enviado_em: string | null;
  contrato_assinado_em: string | null;
  whatsapp_grupo_em: string | null;
  grupo_id: string | null;
  onboarding_msg_em: string | null;
  reuniao_onboarding_em: string | null;
  reuniao_link: string | null;
  onboarding_concluido_em: string | null;
  treino_comercial_em: string | null;
  treino_conteudo_em: string | null;
  observacoes: string | null;
  atualizado_por: string | null;
  atualizado_em: string;
  created_at: string;
  contrato_confirmado_em: string | null;
  contrato_confirmado_por: string | null;
}

/** Tabela handoffs (comercial → operação). */
export interface Handoff {
  id: string;
  cliente_id: string | null;
  nome_cliente: string | null;
  criado_por: string | null;
  link_reuniao: string | null;
  plano_acordado: string | null;
  valor_acordado: number | null;
  termos_notas: string | null;
  criado_em: string;
}

/** Auditoria de mudança de etapa. */
export interface StageHistory {
  id: string;
  cliente_id: string;
  de_stage: number | null;
  para_stage: number | null;
  em: string;
  por: string | null;
  nota: string | null;
}

/** Resposta da Edge Function contract-intake. */
export interface IntakeChoice {
  field: string;
  label: string;
  options: string[];
}

export interface IntakeResponse {
  status: "coletando" | "created" | "disparado" | "pendencia" | "erro";
  message?: string;
  next_question?: string;
  multiple_choice?: IntakeChoice | null;
  dados_parcial?: Record<string, unknown>;
  dados?: Record<string, unknown>;
  missing?: string;
  cliente_id?: string | null;
}

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

/** Linha da tabela grupos (grupos WhatsApp). */
export interface Grupo {
  grupo_id: string; // formato "120363…-group" (= phone da Z-API)
  nome: string | null;
  grupo_link: string | null;
}

/** Resposta da Edge Function whatsapp-group-resolve. */
export interface ResolveGrupoResponse {
  ok: boolean;
  grupo?: Grupo;
  message?: string;
}
